import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { mergeStyleSets, SelectableOptionMenuItemType, Stack, Dropdown, SearchBox, Text, Link } from '@fluentui/react';
import { useState, useMemo } from 'react';
import { markets } from '../../../../../../data/markets.esm.js';
import { LEARN_MORE_LINK_URL } from './constants.esm.js';
import { useTranslation } from 'react-i18next';

/* istanbul ignore file */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    link: {
        textDecoration: 'underline'
    },
    dropdownCallout: {
        padding: '8px',
        width: 'auto'
    },
    dropdownList: {
        maxHeight: 248,
        overflowY: 'auto'
    }
});
var dropdownStyles = {
    dropdownItemsWrapper: {
        overflowY: 'hidden'
    }
};
var searchTermIsMatching = function(searchTerm, value) {
    return value.toLowerCase().startsWith(searchTerm.toLowerCase());
};
var MarketDropdown = function(param) {
    var market = param.market, onMarketChange = param.onMarketChange, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var _useState = _sliced_to_array(useState(''), 2), marketSearchTerm = _useState[0], setMarketSearchTerm = _useState[1];
    var marketOptions = useMemo(function() {
        return markets.map(function(r) {
            var name = r.name, transactable = r.transactable;
            return {
                key: name,
                text: transactable ? name : "".concat(name, "*"),
                itemType: SelectableOptionMenuItemType.Normal,
                data: r,
                hidden: !searchTermIsMatching(marketSearchTerm, name) && market.name === name
            };
        }).filter(function(item) {
            return marketSearchTerm && !item.hidden ? searchTermIsMatching(marketSearchTerm, item.text) : true;
        });
    }, [
        market.name,
        marketSearchTerm
    ]);
    var t = useTranslation('header').t;
    return /*#__PURE__*/ jsxs(Stack, {
        tokens: {
            childrenGap: 5
        },
        children: [
            /*#__PURE__*/ jsx(Dropdown, {
                placeholder: t('Select') || '',
                label: t('Billing country') || undefined,
                options: marketOptions,
                selectedKey: market.name,
                styles: dropdownStyles,
                disabled: disabled,
                onChange: function(_, item) {
                    return onMarketChange(item === null || item === void 0 ? void 0 : item.data);
                },
                onDismiss: function() {
                    return setMarketSearchTerm('');
                },
                onRenderList: function(props, defaultRender) {
                    return /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx(Stack, {
                                className: classNames.dropdownCallout,
                                children: /*#__PURE__*/ jsx(SearchBox, {
                                    placeholder: t('Search') || '',
                                    onChange: function(_, value) {
                                        return setMarketSearchTerm(value || '');
                                    },
                                    value: marketSearchTerm
                                })
                            }),
                            /*#__PURE__*/ jsx(Stack, {
                                className: classNames.dropdownList,
                                children: defaultRender === null || defaultRender === void 0 ? void 0 : defaultRender(props)
                            })
                        ]
                    });
                }
            }),
            !market.transactable && /*#__PURE__*/ jsxs(Text, {
                variant: "smallPlus",
                children: [
                    t('* This billing country only supports apps that don’t require purchasing.'),
                    ' ',
                    "\xa0",
                    /*#__PURE__*/ jsx(Link, {
                        href: LEARN_MORE_LINK_URL,
                        className: classNames.link,
                        target: "_blank",
                        rel: "noreferrer",
                        children: t('Learn more')
                    })
                ]
            })
        ]
    });
};

export { MarketDropdown as default };
